import React from 'react';

import styled from 'styled-components';

import SnapshotEditorModalSelectionItemDate from './SnapshotEditorModalSelectionItemDate';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
`;

const Description = styled.div`
  display: flex;
  color: var(--text-secondary);
  font-size: 14px;
  padding: 5px 30px 20px;
`;

const SnapshotEditorModalSelection = () => {
  return (
    <Container>
      <Description>Add historical data for a particular date.</Description>
      <SnapshotEditorModalSelectionItemDate />
    </Container>
  );
};

export default SnapshotEditorModalSelection;
